import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import FeatureRequestListPage from "../../components/Feature Request/FeatureRequestList";

const FeatureRequestList = () => {
    return (
        <>
     
            <MasterLayout>
                <Breadcrumb title="Feature Request" />
                <FeatureRequestListPage />
            </MasterLayout>
        </>
    );
};

export default FeatureRequestList;
